module.exports = __webpack_public_path__ + "static/media/ras.95000996.png";